// REACT_APP_BACKEND_URL is inlined by CRA at build time; unset => App Engine backend.
export const backendUrl = process.env.REACT_APP_BACKEND_URL || "https://backend.minnatulaleem.com" // without trailing slash
// export const backendUrl = "http://localhost:8000" // without trailing slash

export const microsoftLoginPath = "/accounts/microsoft/login/?process=login"
export const googleLoginPath = "/accounts/google/login/?process=login"
export const tokenVerifyPath = "/accounts/token/verify/"
export const logoutPath = "/accounts/logout/"
// querying
export const queryPath = "/api/query/"
export const queryDetailPath = "/api/detail/"
export const querySave='/api/save/'
export const queryUrl = "/api/signedurl/"
export const imageUrl = "/api/image/"
export const signedImageUrl = "/api/signed-image-url/"
export const customtab="/api/customtab/"
export const queryBookmarkPath='/bookmarks/save/'
export const getqueryBookmarkPath='/bookmarks/get/'
export const saveFeedbackPath='/feedback/save/'
export const summaryPath='/api/summary/'
export const summaryAccessPath='/accounts/ai_summary_access/'

// Image storage
export const imageBaseUrl = "https://pub-5b5ac2f9b1d8474ea0b3f21c16c9c4e8.r2.dev"
export const imageBucketName = "ma-books-images"


// history
export const historyPath = "/api/history/"
// pdf export
export const requestPDFPath = "/export/request/"
export const takeawayPDFPath = "/export/takeaway/"
// filters metadata
export const filtersMetadataPath = "/filters-metadata/"


// Index names
export const ALL_TABS_INDEX= 'all_indices'
export const URDU_BOOKS_INDEX = 'new_urdu_books'
export const ENGLISH_BOOKS_INDEX = 'new_english_books'
export const ARABIC_BOOKS_INDEX = 'arabic_books'
export const ROR_INDEX = 'review_of_religions'
export const ALFAZAL_INDEX = 'new_alfazal'
export const HOLY_QURAN_INDEX = 'holy_quran_new'
export const ASK_ISLAM_INDEX = 'ask_islam'
export const DARSUL_QURAN_INDEX = 'darsul_quran'
export const THIS_WEEK_WITH_HUZOOR_INDEX = 'this_week_with_huzoor'
export const BEACON_OF_GUIDANCE_INDEX = 'beacon_of_guidance'
export const ALBADAR_INDEX = 'albadar'
export const ALHAKAM_INDEX = 'alhakam'
export const MUSLIM_SUNRISE_INDEX = 'muslim_sunrise'
export const FRIDAY_SERMON = 'friday_sermon'
export const FRIDAY_SERMON_ARABIC = 'friday_sermon_new'
export const AK_DIARIES = 'ak_diaries'
export const GERMAN_BOOKS='german_books'
export const HISTORY='history'
// export const NEW_URDU_BOOKS='new_urdu_books'
// export const NEW_ENGLISH_BOOKS='new_english_books'
export const AL_REHMAT_INDEX='al-rehmat'
export const AL_FURQAN_INDEX='al-furqan'
export const TASHEEZ_UL_AZHAN_INDEX='tasheez-ul-azhan'
export const PERIODICALS='periodicals'




